// 3rd-party modules
import { Typography } from "antd";

// project modules
import useTranslation from "../hooks/TranslationContext";
import SpecificDateCreatedReceiptsCountReport from "../components/report/SpecificDateCreatedReceiptsCountReport";
import SpecificDateReceivesAmountReport from "../components/report/SpecificDateReceivesAmountReport";
import SpecificDateSellsAmountReport from "../components/report/SpecificDateSellsAmountReport";

export default function IndexPage() {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <Typography.Title level={4}>{t("home")}</Typography.Title>
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Progress Card */}
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateCreatedReceiptsCountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateReceivesAmountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateSellsAmountReport/>
        </div>
      </div>
      {/* <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 gap-6 pt-6">
        <div className="p-0 pt-5 md:p-5 bg-white shadow rounded col-span-1">
          <SellServiceSummeryReport />
        </div>
        <div className="p-0 pt-5 md:p-5 bg-white shadow rounded col-span-1">
          <SellServiceItemSummeryReport />
        </div>
      </div> */}
    </>
  );
}
